import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { CardBigNumbers, QUERY_FILTER_MARKET_BOOKSTORE, QueryFilter } from 'src/component/shared';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareRankingProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareRankingState {
    customFilter: {
        isChart: boolean
    },
}

const RANKING_QUERY = gql`
query marketShareBookstoreShareRanking($customFilter: MarketShareCustomFilter) {
    marketShareBookstoreShareRanking(marketShareCustomFilter: $customFilter) {
        position
  }
}
`;

export class MarketShareBookstoreShareRanking extends React.Component<IMarketShareBookstoreShareRankingProps, IMarketShareBookstoreShareRankingState> {

    constructor(props: IMarketShareBookstoreShareRankingProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };
        return (
            <Query query={QUERY_FILTER_MARKET_BOOKSTORE} notifyOnNetworkStatusChange={true} >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                return (
                    <Query query={RANKING_QUERY} variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, [], false)} >
                    {({ loading, error, data}) => {

                        let firstValue = null;
                        if(data && data.marketShareBookstoreShareRanking != null && data.marketShareBookstoreShareRanking !== undefined) {
                            firstValue  = data.marketShareBookstoreShareRanking.position;
                        }

                        return  (
                            <CardBigNumbers
                                conversionType='NumberLessBRL'
                                firstValue={firstValue}
                                loading={loading}
                                title='Ranking Grupo'
                            />
                        )
                    }}
                    </Query>
                );
            }}
            </Query>
        );
    }
    
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/marketShare/ranking/MarketShareBookstoreShareRanking.tsx